/* External dependencies */
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';
import { styled, StyleObject } from 'styletron-react';

/* Local dependencies */
import { theme } from '../../layout/constants/theme';
import { DashboardTab } from './types';

interface MobileTabsProps {
  activeTab?: DashboardTab;
  onTabChange: (tab: DashboardTab) => void;
  showActiveTab?: boolean;
}

export function MobileTabs(props: MobileTabsProps) {
  const { activeTab, onTabChange, showActiveTab = true } = props;

  const { t } = useTranslation();

  return (
    <TabsContainer>
      <Tab $active={showActiveTab && activeTab === 'orders'} onClick={() => onTabChange('orders')}>
        {t('dashboard-recent-packages')}
      </Tab>
      <Tab $active={showActiveTab && activeTab === 'address'} onClick={() => onTabChange('address')}>
        {t('dashboard-usa-address')}
      </Tab>
    </TabsContainer>
  );
}

const TabsContainer = styled(
  'div',
  (): StyleObject => ({
    display: 'none',

    [theme.layout.maxMediaQueries.md]: {
      display: 'flex',
      gap: theme.layout.spacing.xs,
      padding: theme.layout.spacing.xs,
      backgroundColor: '#F3F4F6',
      borderRadius: theme.layout.rounded.rounded_10,
    },
  }),
);

const Tab = styled(
  'button',
  ({ $active }: { $active: boolean }): StyleObject => ({
    flex: 1,
    padding: `${theme.layout.spacing.s} ${theme.layout.spacing.m}`,
    backgroundColor: $active ? theme.colors.white : 'transparent',
    color: $active ? theme.colors.primary : theme.colors.text_gray,
    border: 'none',
    borderRadius: theme.layout.rounded.rounded_10,
    fontSize: theme.typography.s,
    fontFamily: theme.typography.onest,
    fontWeight: $active ? theme.typography.semibold : theme.typography.normal,
    cursor: 'pointer',
    transition: `all ${theme.layout.transitions.fast}`,
    whiteSpace: 'nowrap',

    ':hover': {
      backgroundColor: $active ? theme.colors.white : '#E5E7EB',
    },

    ':active': {
      transform: 'scale(0.98)',
    },
  }),
);
